import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_661024ed-50d4-4d78-a636-dd6004c5bf2a/artifacts/ri07y6ac_WhatsApp%20Image%202026-02-10%20at%2015.11.53.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1A365D] text-white" data-testid="footer">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo y Descripción */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Fornes e Hijos" 
              className="h-20 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Especialistas en yesos, pladur y sistemas PYL en Motril. 
              Más de 30 años de experiencia en el sector de la construcción.
            </p>
          </div>

          <div className="lg:col-span-1">
            <h4 className="font-heading text-xl font-bold uppercase tracking-wide mb-6">
              Enlaces
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-home">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/productos" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-productos">
                  Productos
                </Link>
              </li>
              <li>
                <Link to="/servicio-obra" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-servicio">
                  Servicio a Obra
                </Link>
              </li>
              <li>
                <Link to="/sobre-nosotros" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-nosotros">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/formacion" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-formacion">
                  Formación
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-blog">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-link-contacto">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="font-heading text-xl font-bold uppercase tracking-wide mb-6">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#3182CE] flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:858130213" className="text-gray-300 hover:text-white transition-colors block" data-testid="footer-phone-1">
                    858 130 213
                  </a>
                  <a href="tel:622339574" className="text-gray-300 hover:text-white transition-colors block text-sm" data-testid="footer-phone-2">
                    622 339 574 (Asesoramiento Técnico y Comercial)
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#3182CE] flex-shrink-0 mt-0.5" />
                <a href="mailto:fornesehijos@gmail.com" className="text-gray-300 hover:text-white transition-colors" data-testid="footer-email">
                  fornesehijos@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#3182CE] flex-shrink-0 mt-0.5" />
                <a 
                  href="https://www.google.com/maps/place/Fornes+e+Hijos/@36.7275346,-3.5402629,17z"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                  data-testid="footer-address"
                >
                  Polígono Alborán, C. Mar Cantábrico, Nave 3<br />
                  18613 Motril, Granada
                </a>
              </li>
            </ul>
          </div>

          {/* Horario */}
          <div>
            <h4 className="font-heading text-xl font-bold uppercase tracking-wide mb-6">
              Horario
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#3182CE] flex-shrink-0 mt-0.5" />
                <div className="text-gray-300">
                  <p className="font-medium text-white">Lunes - Viernes</p>
                  <p>07:30 - 13:30</p>
                  <p>15:30 - 18:00</p>
                </div>
              </li>
              <li className="flex items-start gap-3 mt-4">
                <Clock className="w-5 h-5 text-[#3182CE] flex-shrink-0 mt-0.5" />
                <div className="text-gray-300">
                  <p className="font-medium text-white">Sábados</p>
                  <p>Solo bajo pedido</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-[#2D3748]">
        <div className="section-container py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© {currentYear} Fornes e Hijos. Todos los derechos reservados.</p>
            <p>Especialistas en Yesos y Pladur en Motril, Granada</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
